import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useQueryClient } from 'react-query';
import {
  LoginDetails,
  useAuthenticateEntityMutation,
} from '../../api/useAuthenticateEntityMutation';
import { useRouteParams } from '../../hooks/useRouteParams';
import {
  loginDetailsInitialValues,
  loginDetailsValidation,
} from './AuthenticateFidelityEntity.validation';
import { toast } from '../../../CommonComponents/OPL/Toast/Toast';
import { queryKeys } from '../../api/queryKeys';
import { useDocumentVaultContext } from '../../context/useDocumentVaultContext';
import { useNavigate } from '../../hooks/useNavigate';

export const useAuthenticateFidelityEntity = () => {
  const queryClient = useQueryClient();

  const { clientId } = useRouteParams();

  const { mutateAsync: authenticateEntity, isError, isLoading } = useAuthenticateEntityMutation();

  const navigate = useNavigate();

  const { selectedEntity, setSelectedEntity } = useDocumentVaultContext();

  const formBag = useForm<LoginDetails>({
    defaultValues: loginDetailsInitialValues,
    resolver: yupResolver(loginDetailsValidation),
  });

  const onAuthenticateEntity = async (loginDetails: LoginDetails) => {
    try {
      await authenticateEntity({ clientId, loginDetails });
      await queryClient.invalidateQueries(queryKeys.fidelityAvailableUsersList(clientId));

      if (!selectedEntity) {
        return null;
      }

      if (selectedEntity.forceUserAuthentication) {
        setSelectedEntity({ ...selectedEntity, forceUserAuthentication: false });
      }

      navigate({
        path: encodeURIComponent(selectedEntity.path),
        providerType: selectedEntity.providerType,
        filterableByYear: selectedEntity.filterableByYear,
      });

      return toast.success('You have successfully logged into Fidelity Documents');
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
    }
  };

  return {
    data: {
      formBag,
      isError,
      isLoading,
    },
    actions: {
      onAuthenticateEntity,
    },
  };
};
